import { render } from "./insurance_confirmation.vue?vue&type=template&id=0ecf24de&scoped=true"
import script from "./insurance_confirmation.vue?vue&type=script&lang=js"
export * from "./insurance_confirmation.vue?vue&type=script&lang=js"

import "./insurance_confirmation.vue?vue&type=style&index=0&id=0ecf24de&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecf24de"]])

export default __exports__